import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { CreateMunicipalPropertyRegisterInput } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createMunicipalPropertyRegisterMutationDocument } from "./create-municipal-property-register-mutation.gql";
import { EVENT_MUNICIPAL_PROPERTY_REGISTER_CREATED, trackMunicipalPropertyEvent } from "./tracking";

export const useCreateMunicipalPropertyRegister = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateMunicipalPropertyRegisterInput) => {
      const client = createOperationClient("CreateMunicipalPropertyRegister");
      const response = await client.request(createMunicipalPropertyRegisterMutationDocument, { input });
      return response.createMunicipalPropertyRegister;
    },
    onSuccess: async (register, input) => {
      trackMunicipalPropertyEvent(EVENT_MUNICIPAL_PROPERTY_REGISTER_CREATED, {
        id: register.id,
        year: register.year,
        workspaceId: input.workspaceId,
      });
      await refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId: input.workspaceId, propertyIdList: [] } });
    },
  });
};
